export enum ESubscriptionState {
  Active = 'active',
  Expiring = 'expiring',
  Expired = 'expired'
}

export enum ESubscriptionManagerPart {
  Billing_Info = 'billing_info',
  Billing_History = 'billing_history',
  Transaction_Info = 'transaction_info'
}

export enum ETransactionInfoType {
  ICON = 'icon',
  DISPLAY = 'display',
  TEMPLATE = 'template'
}

export enum EPurchaseState {
  Paid = 'paid',
  Canceled = 'canceled'
}

export enum EPurchaseType {
  MEDIA = 'unlock_media',
  VOICE_CALL = 'voice_call',
  TOKENS = 'purchase_tokens',
  GENERATE_IMAGE = 'generate_image',
  SUBSCRIPTION = 'purchase_subscription',
  TOKENS_TOPUP = 'tokens_topup'
}

export enum ETransactionCurrency {
  USD = 'USD',
  TOKENS = 'TOKENS'
}
